<template>
  <div class="wrap" :class="{'is-loading': loading}">
    <div class="col-map">
      <div style="position:relative; overflow: hidden">
        <cw-map :map="map" v-if="map"
                :active-entity="activeObject"
                :sunstudyView="sunstudyView"
                :sunstudySlide="sunstudySlide"
                ref="mainMap"
                @regionclick="onRegionClick"
                @regionmousemove="onRegionMousemove"
                @regionmouseleave="onRegionMouseLeave"></cw-map>

        <cw-filter :visible="showFilter"></cw-filter>

        <button type="button" @click="toggleFilter" class="btn cw-map-filter-toggle">
          <span v-if="!showFilter">Filtrera val</span>
          <span v-if="showFilter">Minimera</span>
        </button>

        <div class="map-loader" :class="{'is-visible': loading}">
          <div class="progress" v-if="sunstudyLoading">
            <div class="progress-bar"
                 :style="{width: (sunstudyLoading.finished / sunstudyLoading.total)*100 + '%' }"></div>
          </div>
        </div>

        <cw-object-popup :object="activeObject" :position="mousePosition" v-if="mousePosition"></cw-object-popup>

        <div class="map-overview"
             @mouseover="onOverviewMouseover"
             @mouseout="onOverviewMouseout">
          <cw-map :map="overviewMap" v-if="overviewMap" ref="overview"
                  @regionclick="onOverviewRegionClick"
                  :active-entity="map"
                  v-bind:style="{width: overviewSize + '%', zIndex: overviewActive ? 1000 : 10}"></cw-map>
        </div>

        <nav class="cw-map-nav">
          <button @click="goPrev()" class="cw-map-nav-prev"><span class="icon icon-arrow-left"></span></button>
          <button @click="goNext()" class="cw-map-nav-next"><span class="icon icon-arrow-right"></span></button>
        </nav>
      </div>

      <cw-sunstudy-controls v-if="map.sunstudy"
                            :sunstudy="map.sunstudy" class="col-sunstudy-controls"
                            :view="sunstudyView"
                            :slide="sunstudySlide"
                            @view="onSunstudyViewChange"
                            @slide="onSunstudySlide"></cw-sunstudy-controls>

      <router-view :map="map"></router-view>
    </div>

    <div class="col-list" v-if="!hideObjectList">
      <cw-object-list :objects="objects"
                      :active-object="activeObject"
                      @rowclick="onRowClick"
                      @rowmouseenter="onRowMouseEnter"
                      @rowmouseleave="onRowMouseLeave"></cw-object-list>
    </div>
  </div>
</template>

<script>
  import Map from '@/components/Map'
  import Spinner from '@/components/Partials/Spinner'
  import MapFilter from '@/components/MapFilter'
  import ObjectList from '@/components/ObjectList'
  import ObjectPopup from '@/components/ObjectPopup'
  import SunstudyControls from '@/components/Partials/SunstudyControls'
  import {pad} from '../functions'
  import {mapGetters} from 'vuex'

  export default {
    name: 'Map',
    props: ['widget'],
    data () {
      return {
        showFilter: false,
        loadedSunstudies: [],
        sunstudyLoading: null,
        sunstudyView: null,
        sunstudySlide: null,
        loading: true,
        mousePosition: null,
        activeObject: null,
        overviewActive: false,
        map: null,
        overviewMap: null,
        height: null,
        width: null,
        zoom: null
      }
    },
    computed: {
      objects () {
        return this.objectsFiltered.filter(object => {
          return this.map.regions.data.findIndex(region => {
            return region.object && region.object.id === object.id
          }) > -1
        })
      },
      overviewSize () {
        return this.overviewActive ? 40 : 15
      },
      ...mapGetters({
        objectsFiltered: 'getObjects'
      })
    },
    watch: {
      '$route.params.id' (to, from) {
        this.init()
      },
      sunstudyView () {
        if (this.loadedSunstudies.indexOf(this.sunstudyView.id) > -1) {
          this.loading = false
          return
        }

        this.loading = true

        this.preloadSunstudyView(this.sunstudyView).then((loadedView) => {
          this.loadedSunstudies.push(loadedView.id)
          setTimeout(() => {
            this.loading = false
          }, 500)
        })
      }
    },
    created () {
      this.init()

      window.addEventListener('resize', () => {
        this.resize()
      })
    },
    mounted () {
      this.$nextTick(() => {
        this.resize()
      })
    },
    methods: {
      init () {
        const id = this.$route.params.id
        this.map = this.widget.object_maps.data.find(m => m.id === +id)
        if (!this.map) {
          this.navigate('')
        }

        this.loading = true

        // this.parseObjects()

        this.overviewMap = this.widget.overview_maps.data[0]

        if (!this.widget.template_config) {
          throw new Error('no template config')
        }

        this.hideObjectList = this.widget.template_config.hide_object_list || false
        this.externalLinks = this.widget.settings.external_links
        this.externalLinkBase = this.widget.settings.external_link_base

        if (this.map.sunstudy) {
          this.sunstudyView = this.map.sunstudy.views.data[0]
          this.sunstudySlide = this.sunstudyView.start_frame
        } else {
          this.loading = false
        }

        if (!this.map) {
          throw new Error('karta hittas inte')
        }

        this.$nextTick(() => {
          this.resize()
        })
      },
      toggleFilter () {
        this.showFilter = !this.showFilter
      },
      goNext () {
        const idx = this.widget.object_maps.data.findIndex(m => m.id === this.map.id)
        let next

        if (this.widget.object_maps.data.length > idx + 1) {
          next = this.widget.object_maps.data[idx + 1]
        } else {
          next = this.widget.object_maps.data[0]
        }

        this.navigate(`map/${next.id}`)
      },
      goPrev () {
        const idx = this.widget.object_maps.data.findIndex(m => m.id === this.map.id)
        let next

        if (idx > 0) {
          next = this.widget.object_maps.data[idx - 1]
        } else {
          next = this.widget.object_maps.data[this.widget.object_maps.data.length - 1]
        }

        this.navigate(`map/${next.id}`)
      },

      onSunstudySlide (slide) {
        this.sunstudySlide = slide
      },
      onSunstudyViewChange (view) {
        this.sunstudyView = view
      },
      onOverviewRegionClick (region) {
        this.navigate(`map/${region.entity_id}`)
      },
      onOverviewMouseover () {
        this.overviewActive = true
        this.$nextTick(() => {
          this.$refs.overview.resize()
        })
      },

      onOverviewMouseout () {
        this.overviewActive = false
        this.$nextTick(() => {
          this.$refs.overview.resize()
        })
      },

      preloadSunstudyView (view) {
        return new Promise((resolve, reject) => {
          let promises = []
          this.sunstudyLoading = {total: view.image_count, finished: 0}
          for (let i = 0; i <= view.image_count - 1; i++) {
            const num = pad('0000', i, true)
            const url = window.innerWidth > 640
              ? `${`${view.base_url}/${num}-1200.jpg`}`
              : `${`${view.base_url}/${num}-640.jpg`}`

            promises.push(new Promise((imgResolve, imgReject) => { // eslint-disable-line
              let image = new Image()
              image.addEventListener('load', () => {
                this.sunstudyLoading['finished']++
                imgResolve()
              }, false)
              image.addEventListener('error', () => {
                this.sunstudyLoading['finished']++
                imgResolve()
              }, false)
              image.src = url
            }))
          }

          Promise.all(promises).then(values => {
            resolve(view)
          })
        })
      },
      navigate (url) {
        this.$router.push(`/${this.$route.params.template}/${this.$route.params.slug}/${url}`)
      },
      onRowClick (row) {
        if (this.externalLinks) {
          if (row.data['url']) {
            window.top.location.href = `${this.externalLinkBase ? this.externalLinkBase : ''}${row.data['url']}`
          }
        } else {
          this.navigate(`map/${this.$route.params.id}/object/${row.id}`)
        }
      },
      onRowMouseEnter (row) {
        this.activeObject = row
      },
      onRowMouseLeave (row) {
        this.activeObject = null
      },
      resize () {
        const ratio = this.map.height / this.map.width

        this.width = this.$el.clientWidth
        this.height = this.width * ratio

        this.zoom = this.width / this.map.width

        this.$store.commit('setMainSize', [this.width, this.height])
      },
      onRegionClick (region) {
        if (this.externalLinks) {
          if (region.object.data['url']) {
            window.top.location.href = `${this.externalLinkBase ? this.externalLinkBase : ''}${region.object.data['url']}`
          }
        } else {
          this.navigate(`map/${this.$route.params.id}/object/${region.object.id}`)
        }
      },
      onRegionMousemove (region, e) {
        this.mousePosition = {x: e.clientX, y: e.clientY}

        if (e.offsetX + 250 > this.width) {
          this.mousePosition.x = Math.max(0, this.mousePosition.x - 250)
        }

        if (e.offsetY + 300 > this.height) {
          this.mousePosition.y = Math.max(0, this.mousePosition.y - 300)
        }

        this.activeObject = region.object
      },
      onRegionMouseLeave (region, e) {
        this.activeObject = null
        this.mousePosition = null
      }
    },
    components: {
      'cw-map': Map,
      'cw-spinner': Spinner,
      'cw-sunstudy-controls': SunstudyControls,
      'cw-filter': MapFilter,
      'cw-object-list': ObjectList,
      'cw-object-popup': ObjectPopup
    }
  }
</script>
<style lang="scss">
  @import '~bootstrap/scss/functions';
  @import '~bootstrap/scss/variables';
  @import '~bootstrap/scss/mixins';

  .wrap {
    // display: flex;
    // flex-direction: column;
  }

  .map-loader {
    background: rgba(#fff, 1);
    position: absolute;
    z-index: -1;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    transition: opacity .4s;

    &.is-visible {
      z-index: 1090;
      opacity: 1;
    }

    .progress {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -100px;
    }
  }

  .col-map {
    // flex: 0 0 auto;
    // overflow: hidden;
    position: relative;
    height: auto;
  }

  .col-sunstudy-controls {
    flex: 0 0 auto;
    padding: 10px 0;

    @include media-breakpoint-up(sm) {
      padding: 20px 0;
    }
  }

  .col-list {
    flex: 1 1 auto;
    background: #fff;
    // overflow: auto;
    //min-height: 30%;
  }

  .cw-map {
    position: relative;
  }

  .cw-map .cw-map-wrap {
    position: relative;
  }

  .cw-map .cw-map-wrap .cw-map-image {

  }

  .cw-map .cw-map-wrap .cw-map-svg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    user-select: none;
  }

  .cw-map .cw-map-wrap .cw-map-image {
    z-index: 1;
  }

  .cw-map .cw-map-wrap .cw-map-svg {
    z-index: 10;
  }

  .map-overview {
    position: absolute;
    bottom: 10px;
    left: 10px;
    //width: 100px;
    color: #fff;

    .cw-map {
      // transition: width 0.25s, height 0.25s;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ObjectMap.vue